document.addEventListener("change", function (e) {
  const fieldset = e.target.closest("fieldset.varinat_image_form");
  if (!fieldset) return; // only run for your target fieldset

  // Find the checked input inside .all-opt-wrap
  const checkedInput = fieldset.querySelector('.all-opt-wrap input[type="radio"]:checked');
  if (!checkedInput) return;

  const selectedValue = checkedInput.value.trim();

  // Find all description paragraphs
  const allDescriptions = document.querySelectorAll(".prod-meta-desc .metafield_descript");

  allDescriptions.forEach((desc) => {
    const descTitle = desc.getAttribute("data-desctitle")?.trim();

    if (descTitle === selectedValue) {
      // Match found — make visible and active
      desc.classList.add("active");
      desc.classList.remove("hidden");
    } else {
      // Hide others
      desc.classList.remove("active");
      desc.classList.add("hidden");
    }
  });
});



document.querySelectorAll('slider-component').forEach(slider => {
  const observer = new MutationObserver(() => {
    slider.querySelectorAll('.first_imgg_prod').forEach(el => {
      el.classList.remove('first_imgg_prod');
    });
  });

  observer.observe(slider, {
    childList: true,
    subtree: true,
    attributes: true,
    characterData: true
  });
});